// extracted by mini-css-extract-plugin
module.exports = {"Trainer":"TeamTrainers-module--Trainer--jq1UX"};